import {useCallback, useMemo} from "react";

export const useNoteReplies = ({ userId, displayNotes = [] }) => {
  // Create a map for quick lookup of notes by ID
  const notesById = useMemo(() => {
    const map = new Map();
    displayNotes.forEach(note => {
      if (note && note.id) map.set(String(note.id), note);
    });
    return map;
  }, [displayNotes]);

  // Check if a note is a reply
  const isNoteReply = useCallback(
    (noteId) => {
      const note = notesById.get(String(noteId));
      return note ? note.isReply === 1 : false;
    },
    [notesById]
  );

  // Get the original note ID for a reply note
  const getReplyNoteId = useCallback(
    (replyNoteId) => {
      const note = notesById.get(String(replyNoteId));
      return note && note.isReply === 1 ? note.originalSNId : null;
    },
    [notesById]
  );

  // Check if the original note still exists in the current displayNotes
  const isOriginalNoteExists = useCallback(
    (originalNoteId) => {
      if (!originalNoteId) return false;
      return notesById.has(String(originalNoteId));
    },
    [notesById]
  );

  return {
    isNoteReply,
    getReplyNoteId,
    isOriginalNoteExists,
  };
};